module.exports = __webpack_public_path__ + "img/dashboardMHH2.edeedba7.png";